import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Button } from './Button';
export function CircleButton(_a) {
    var { size = 's' } = _a, rest = __rest(_a, ["size"]);
    return (_jsx(Button, Object.assign({ alignItems: "center", borderRadius: "50%", display: "flex", isSquare: true, justifyContent: "center", kind: "ghost", px: 0, size: size }, rest)));
}
